/**
 * Test IDs for QA automation.
 */
export const testIds = {
  supplierContractsListNewContract: "supplier-contracts-list-new-contract",
} as const;
